export const policyMarkdownStyles = {
  body: { color: '#fafafa', fontSize: 14 },
  heading1: { color: '#ffffff', fontSize: 20, fontWeight: '700' as const, marginBottom: 8 },
  heading2: { color: '#ffffff', fontSize: 18, fontWeight: '700' as const, marginBottom: 6 },
  heading3: { color: '#ffffff', fontSize: 16, fontWeight: '600' as const, marginBottom: 4 },
  strong: { fontWeight: '700' as const, color: '#ffffff' },
  link: { color: '#9ACD32' },
  list_item: { marginBottom: 4, color: '#fafafa' },
  paragraph: { marginBottom: 8, color: '#fafafa' },
  bullet_list: { color: '#fafafa' },
  ordered_list: { color: '#fafafa' },
  blockquote: { backgroundColor: '#27272a', borderLeftColor: '#9ACD32', borderLeftWidth: 3, paddingHorizontal: 12, paddingVertical: 8, marginVertical: 8 },
  code_inline: { backgroundColor: '#27272a', color: '#fafafa' },
  code_block: { backgroundColor: '#27272a', color: '#fafafa' },
  fence: { backgroundColor: '#27272a', color: '#fafafa' },
};
